<template>
     <p>Reaction Time : {{ score }} ms</p>
     <p class="rank">{{ rank }}</p>
</template>

<script>
export default {
    props: ['score'],
    data() {
        return{
            rank: null
        }
    },
    mounted() {
        if (this.score < 250) {
            this.rank = "Ninja Fingers! OMG!!"
        } else if (this.score < 400) {
            this.rank = "Rapid Reflexes! GOOD!"
        } else {
            this.rank = "Snail pace... Sorry!"
        }
    }
}
</script>

<style>
 .rank {
    font-size: 1.4em;
    color: #0faf87;
    font-weight: bold;
 }
</style>